import Vue from 'vue'
// import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import modules from './store/modules'
import store from './api'
import axios from 'axios'
import './plugins'
import vuetify from './plugins/vuetify'
import { sync } from 'vuex-router-sync'
import VueMoment from 'vue-moment'
import VueClipboard from 'vue-clipboard2'
import moment from 'moment-timezone'

Vue.config.productionTip = false
Vue.config.devtools = process.env.NODE_ENV === 'development'

sync(store, router)
store.registerModule('app', modules.app)

// catch 401's and redirect to Unauth page
axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  console.log(error.response.data)
  if (error.response.data.status === 401) {
    router.push('/unauthorized')
  }
  return Promise.reject(error)
})

// Allow moment filters
Vue.use(VueMoment, {
  moment,
})

// Allow clipboard
Vue.use(VueClipboard)

// Vue Filters
Vue.filter('prepend', function (value, nval) {
  return nval + value
})
Vue.filter('localFromUTC', function (dt) {
  return moment.utc(dt).local().format('YYYY/MM/DD HH:mm:ss')
})
Vue.filter('displayName', function (user) {
  if (user.first_name !== undefined) {
    return (user.support ? '(Staff) ' : '') + '(' + user.user + ') ' + user.first_name + ' ' + user.last_name
  }
  return ''
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
